export const allowedCountriesDialCodePattern =
    "\\+(998|996|995|994|993|992|977|976|975|974|973|972|971|970|968|967|966|965|964|963|962|961|960|886|880|856|855|853|852|850|692|691|690|689|688|687|686|685|683|682|681|680|679|678|677|676|675|674|673|672|670|599|598|597|596|595|594|593|592|591|590|509|508|507|506|505|504|503|502|501|500|423|421|420|389|387|386|385|383|382|381|380|378|377|376|375|374|373|372|371|370|359|358|357|356|355|354|353|352|351|350|299|298|297|291|290|269|268|267|266|265|264|263|262|261|260|258|257|256|255|254|253|252|251|250|249|248|246|245|244|243|242|241|240|239|238|237|236|235|234|233|232|231|230|229|228|227|226|225|224|223|222|221|220|218|216|213|212|211|98|95|94|93|92|91|90|86|84|82|81|66|65|64|63|62|61|60|58|57|56|55|54|53|52|51|49|48|47|46|45|44|43|41|40|39|36|34|33|32|31|30|27|20|7|1)";
export const allowedCountries = [
    "af",
    "al",
    "dz",
    "ad",
    "ao",
    "ar",
    "am",
    "au",
    "at",
    "az",
    "bh",
    "bd",
    "by",
    "be",
    "bz",
    "bj",
    "bt",
    "bo",
    "ba",
    "bw",
    "br",
    "bn",
    "bg",
    "bf",
    "bi",
    "kh",
    "cm",
    "ca",
    "cg",
    "cf",
    "cv",
    "td",
    "cl",
    "cn",
    "cx",
    "cc",
    "co",
    "cd",
    "do",
    "eh",
    "fk",
    "gf",
    "kp",
    "kr",
    "ps",
    "sr",
    "nf",
    "sz",
    "gy",
    "km",
    "ck",
    "cr",
    "hr",
    "cy",
    "cz",
    "dk",
    "dj",
    "tl",
    "ec",
    "eg",
    "sv",
    "gq",
    "gn",
    "er",
    "ee",
    "fo",
    "fj",
    "fi",
    "fr",
    "pf",
    "ga",
    "gm",
    "ge",
    "de",
    "gh",
    "gi",
    "gr",
    "gt",
    "gn",
    "gn",
    "gw",
    "hn",
    "hk",
    "hu",
    "is",
    "in",
    "id",
    "ir",
    "iq",
    "ie",
    "il",
    "it",
    "ci",
    "jp",
    "jo",
    "kz",
    "ke",
    "ki",
    "xk",
    "kw",
    "kg",
    "la",
    "lv",
    "lb",
    "ls",
    "lr",
    "ly",
    "li",
    "lt",
    "lu",
    "mo",
    "mk",
    "mg",
    "mw",
    "my",
    "mv",
    "ml",
    "mt",
    "mh",
    "mr",
    "mu",
    "mx",
    "fm",
    "md",
    "mc",
    "mn",
    "me",
    "ma",
    "eh",
    "mz",
    "mm",
    "na",
    "np",
    "nl",
    "nc",
    "nz",
    "ne",
    "ne",
    "ng",
    "nu",
    "no",
    "om",
    "pk",
    "pw",
    "pa",
    "gn",
    "pg",
    "py",
    "pe",
    "ph",
    "pl",
    "pt",
    "pr",
    "qa",
    "yt",
    "re",
    "ro",
    "ru",
    "rw",
    "ws",
    "sm",
    "st",
    "sa",
    "sn",
    "rs",
    "sc",
    "sl",
    "sg",
    "sk",
    "si",
    "sb",
    "so",
    "za",
    "ss",
    "sd",
    "es",
    "lk",
    "sd",
    "sz",
    "se",
    "ch",
    "sy",
    "tw",
    "tj",
    "tz",
    "th",
    "tg",
    "to",
    "tn",
    "tr",
    "cy",
    "tm",
    "tv",
    "ug",
    "ua",
    "ae",
    "uk",
    "us",
    "uy",
    "uz",
    "vu",
    "va",
    "ve",
    "vn",
    "ye",
    "zm",
    "zw",
    "gl",
    "gb",
];

export const EMAIL_PATTERN_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+\.?)+|(".+"))@(\[(\d{1,3}\.){3}\d{1,3}]|[a-zA-Z\-0-9]+(\.[a-zA-Z]+)+)$/;

export const PARTICIPANT_TYPE = {
    GUEST: "GUEST",
    SILENT_OBSERVER: "SILENT_OBSERVER",
};

export const TAB_OPTIONS = {
    SMS: "SMS",
    EMAIL: "Email",
    COPY: "COPY",
    WHATSAPP: "WHATSAPP",
};

export const PARTICIPANT_MODAL_TAB = {
    SMS: "SMS",
    EMAIL: "EMAIL",
    COPY: "COPY",
    WHATSAPP: "WHATSAPP",
};

export const COPY_TAB_ITEMS = {
    SESSION_INVITATION: "SESSION_INVITATION",
    SESSION_ID: "SESSION_ID",
    COPY_LINK: "COPY",
};

export const PHONE_NUMBER_REGEX = /[a-zA-Z`~!@$%^&_|=?;:'" ,<>\\]/gi;

export const DEFAULT_COUNTRY_CODE = "US";

export const COPY_SECTIONS = {
    COPY_INVITATION: "COPY_INVITATION",
    COPY_SESSION_CODE: "COPY_SESSION_CODE",
    COPY_SESSION_LINK: "COPY_SESSION_LINK",
};

export const INVITE_TYPE = {
    SMS: 1,
    WhatsApp: 2,
    EMAIL: 3,
    SmartGlass: 4,
    CopyLink: 7,
};
